import React, { useState } from 'react';
import _ from 'lodash';
import cn from 'classnames';
import { notApplicable, getProjectScore, getFullScore } from 'helpers';
import { PREV_TCAS_LABEL } from 'constants/school-year';
import PassChance from './PassChance';
import { MISSING_COURSE_LABEL } from 'hooks/round3/priorities';

// Hooks
import { useSelector } from 'react-redux';
import useIsMobile from 'hooks/useIsMobile';

const FavoriteItem = ({ index, data, studentStatus, favorites, hideAdmissionCount, onRemove }) => {
  const lang = 'th';

  const profile = useSelector((state) => _.get(state, 'app.user') || {});
  const courseMap = useSelector((state) => _.get(state, 'app.courseMap')) || {};
  const admissionCountMap = useSelector((state) => _.get(state, 'app.admissionCountMap')) || {};
  const project = courseMap[data.program_project];
  const majorName = _.get(project, `major_name_${lang}`);
  const projectName = _.get(project, `project_name_${lang}`);
  const errors = notApplicable(profile, project, { studentStatus, favorites });

  const [errorActive, setErrorActive] = useState(false);
  const isMobile = useIsMobile();

  // หลักสูตรหายจาก courses_round3.json — ยังต้องมีปุ่มลบ ไม่งั้นเด็กติดค้าง (บันทึก/ยืนยันถูกบล็อก แต่ลบไม่ได้)
  if (!project) {
    return (
      <li className="error">
        <label style={{ pointerEvents: 'initial', ...(isMobile ? { paddingBottom: 60 } : {}) }}>
          <div className="num"><b>{index + 1}</b></div>
          <strong className="color-red">{MISSING_COURSE_LABEL}</strong>
        </label>
        <i className="i-del cursor-pointer" role="button" aria-label="ลบออกจากสาขาวิชาที่สนใจ" onClick={() => onRemove(data._id)} />
      </li>
    );
  }

  const admissionCountKey = `${project.program_id || 0}_${project.major_id || 0}_${project.project_id || 0}`;
  return (
    <li key={project._id} className={cn({ error: Boolean(errors.length) })}>
      <label style={{ pointerEvents: 'initial', ...(isMobile ? { paddingBottom: 60 } : {}) }}>
        <div className="num"><b>{index + 1}</b></div>
        <h4 className="score" style={isMobile ? { bottom: 38 } : {}}>
          {'คะแนน'} {getProjectScore(profile, project, 1)}/{getFullScore(project)} {_.get(project, 'scores.priority_score') ? ' (กรณีเลือกอันดับที่ 1)' : ''}
          {!errors.length && (
            <PassChance score={getProjectScore(profile, project, 1)} project={project} anchorRight={Boolean(_.get(project, 'scores.priority_score'))} />
          )}
        </h4>
        {!hideAdmissionCount && (
          <h4
            className="score"
            style={isMobile ? { right: 'auto', left: 'auto', bottom: 16, textAlign: 'left' } : { right: 16, left: 'auto' }}
            onClick={() => console.log('score')}
          >
            {`จำนวนผู้สมัคร ${(admissionCountMap[admissionCountKey] || 0).toLocaleString()} คน`}
            {Number(_.get(project, 'last_year_register')) ? (
              <span style={{ color: '#999' }}>{` (${PREV_TCAS_LABEL} : ${Number(_.get(project, 'last_year_register')).toLocaleString()} คน)`}</span>
            ) : null}
          </h4>
        )}
        <span
          className="u-logo"
          style={{ backgroundImage: `url('/assets/img/logo/${_.get(project, 'university_id')}.png')` }}
        />
        <strong>{_.get(project, `university_name_${lang}`)}</strong>
        {_.get(project, `campus_name_${lang}`)}
        <br />
        {_.get(project, `faculty_name_${lang}`)}
        <br />
        {_.get(project, `field_name_${lang}`)}
        <br />
        {majorName && majorName !== '0' ? (
          <>
            {'วิชาเอก'}
            {majorName}
            <br />
          </>
        ) : null}
        {_.get(project, `program_name_${lang}`)}
        <br />
        {lang === 'th' ? `(${_.get(project, `program_type_name_th`)})` : null}
        {projectName && projectName !== '0' ? (
          <>
            <br />
            {'โครงการ '}
            {projectName}
          </>
        ) : null}
      </label>
      {Boolean(errors.length) && (
        <div className={cn('t-collapse', { active: errorActive })}>
          <div className="t-toggle" onClick={() => setErrorActive(_active => !_active)}>
            {'ไม่ผ่านเงื่อนไขการรับ ไม่สามารถสมัครได้'}<i className="i-toggle i-down-red"></i>
          </div>
          <div className="t-content">
            <ul>
              {errors.map(({ messages = [], key, label, expected, value }) => {
                if (messages.length > 1) {
                  return (
                    <li key={key}>
                      <i className="i-no"></i>
                      <span>{messages[0].label}</span>
                      {messages.map(({ expected, value }, index) => (
                        <div key={index}>
                          <b>{expected}</b>
                          <span>({'ผู้สมัคร'}: <b className="color-red">{value}</b>)</span>
                        </div>
                      ))}
                    </li>
                  )
                }
                if (!value && value !== 0) {
                  return (
                    <li key={key}>
                      <i className="i-no"></i>
                      <span>{label}</span>
                    </li>
                  )
                }
                return (
                  <li key={key}>
                    <i className="i-no"></i>
                    <span>{label}</span>
                    <b>{expected}</b>
                    <span>({'ผู้สมัคร'}: <b className="color-red">{value}</b>)</span>
                  </li>
                )
              })}
            </ul>
          </div >
        </div >
      )}
      <i className="i-del cursor-pointer" onClick={() => onRemove(data._id)} />
    </li >
  )
}

export default FavoriteItem;